import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetById } from '../../service/BatchService';
import { Add } from '../../service/ForumService';
import { GetUsersByRole } from '../../service/UserService';
import axios from 'axios';

export default function ForumNew() {
    const {
        isLoading,
        setIsLoading,
        isAppError,
        setAppError,
        appErrorMessage,
        setAppErrorMessage,
        appErrorTitle,
        setAppErrorTitle,
        appErrorMode,
        setAppErrorMode,
        appUser,
    } = useGlobalContext();

    const { batchId } = useParams(); 
    const id = appUser._id; // Get the trainer ID from the appUser context

    const [batchDetails, setBatchDetails] = useState({});

    // Form states
    const [topic, setTopic] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('');

    const fetchBatchDetails = async () => {
        try {
            setIsLoading(true);
            const response = await GetById(batchId);
            if (response?.batch) {
                setBatchDetails(response.batch);
            } else {
                setBatchDetails({});
            }
        } catch (error) {
            setAppError(true);
            setAppErrorTitle("Error");
            setAppErrorMessage("Failed to fetch batch details");
            setAppErrorMode("error");
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchBatchDetails();
    }, []);

    const saveForum = async (event) => {
        event.preventDefault();

        setIsLoading(true);

        try {
            let response = null;
            response = await Add(batchId, id, topic, description);
            if (response.status === 200) {
                setAppError(true);
                setAppErrorTitle("Action Response");
                setAppErrorMessage(response.message || "Lesson planner Successfully Updated");
                setAppErrorMode("success");               
                window.location.href = `/batch/forum/manage/${batchId}`;                
            } else {
                setAppError(true);
                setAppErrorTitle("Error");
                setAppErrorMessage(response.message || "Action failed. Please try again.");
                setAppErrorMode("error");
            }
        } catch (error) {
            setAppError(true);
            setAppErrorTitle("Error");
            setAppErrorMessage("Something went wrong. Please try again.");
            setAppErrorMode("error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Helmet>
                <title> Add Forum | {config.appName}</title>
            </Helmet>
            <div className='container'>
                <div className='page'>
                    <div className='page-heading'>
                        <h1>Add Forum </h1>
                        <span>
                            <Link to="/"> Dashboard </Link> / <Link to={`/batch/forum/manage/list/${batchId}`}> Forum List </Link>
                            / Add Forum
                        </span>
                    </div>

                    <div className='page-content'>
                        <div className="portal">
                            <div className='portal-body'>
                                <div className='batch-details'>
                                    <div className='row'>
                                        <div className='col-lg-3 col-md-3 col-sm-12'>
                                            Category : <strong>{batchDetails?.courseId?.categoryId?.name || '-'}</strong>
                                        </div>
                                        <div className='col-lg-3 col-md-3 col-sm-12'>
                                            Sub Category : <strong> {batchDetails?.courseId?.subCategoryIds
                                                ?.map(sub => sub.name)
                                                .join(", ")}</strong>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12'>
                                            Course : <strong>{batchDetails?.courseId?.name || '-'}</strong>
                                        </div>
                                    </div>
                                </div>
                                <br></br>
                                <div className='batch-details'>
                                    <div className='row'>
                                        <div className='col-lg-3 col-md-3 col-sm-12'>
                                            Batch Code : <strong>{batchDetails?.code || '-'}</strong>
                                        </div>
                                        <div className='col-lg-3 col-md-3 col-sm-12'>
                                            Start Date : <strong>
                                                {batchDetails?.startDate
                                                    ? (() => {
                                                        const date = new Date(batchDetails.startDate);
                                                        const day = String(date.getDate()).padStart(2, '0');
                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                        const year = date.getFullYear();
                                                        return `${day}-${month}-${year}`;
                                                    })()
                                                    : '-'}
                                            </strong>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12'>
                                            Batch Name : <strong>{batchDetails?.name || '-'}</strong>
                                        </div>
                                    </div>
                                </div>
                               <br></br>
                                <div className='row'>
                                    <div className='col-lg-12 col-md-12 col-xs-12'>
                                        <div className='batch-details'>
                                            <form onSubmit={saveForum} encType='multipart/form-data'>
                                                <div className='row'>  
                                                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                                        <div className="mb-3">
                                                            <label className="form-label">Forum Topic</label>
                                                            <input className='form-control' type='text' value={topic} onChange={(e) => setTopic(e.target.value)}
                                                            />
                                                        </div>
                                                    </div> 
                                                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                                        <div className="mb-3">
                                                            <label className="form-label">Forum Description</label>
                                                            <textarea className='form-control' value={description} rows={5} onChange={(e) => setDescription(e.target.value)} />
                                                        </div>
                                                    </div>                                                  
                                                    <div className='col-12 text-end'>
                                                        <div className="mb-3">
                                                            <button type='submit' className='btn btn-success-app btn-md'>
                                                                <i className="ri-check-fill"></i> Add Forum
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
